import { useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';

import GridProvider from './GridProvider';
import { a11yProps, TabPanel } from '../../../../UI/MuiTab';

const TabsProvider = ({
  izvestajSaTerena,
  bazaZnanja,
  handleClickNapomena,
}) => {
  //   const { t, i18n } = useTranslation();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Box sx={{ width: '98%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            style={{ padding: '2px' }}
          >
            <Tab
              label="Beleške"
              sx={{ textTransform: 'none' }}
              {...a11yProps(0)}
            />
            {/* <Tab
              label="Putovanje"
              sx={{ textTransform: 'none' }}
              {...a11yProps(1)}
            /> */}
          </Tabs>
        </Box>
      </Box>
      <TabPanel disabled value={value} index={0}>
        <GridProvider
          data={izvestajSaTerena}
          handleClickNapomena={handleClickNapomena}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <GridProvider
          data={bazaZnanja}
          handleClickNapomena={handleClickNapomena}
        />
      </TabPanel>
    </>
  );
};

export default TabsProvider;
